
(() => {
    if (!customElements.get("media-banner")) {
      class MediaBanner extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.setHtmlElements();
            this.addListeners();
        }
  
        setHtmlElements() {
            this.videoIframe = this.querySelector('.youtube-video');
        }

        toggleVideoAutoplay(target){
            if (target.closest('.player-wrapper') || target.closest('.VideoCard .Button')){
                this.videoIframe.src += '&autoplay=1';
            } else {
                const videoUrl = this.videoIframe.src.replace('&autoplay=1', '');
                if (!target.classList.contains('Modal__box')){
                    this.videoIframe.src = videoUrl;
                }
            }
        }
        addListeners(){
            document.body.addEventListener('click', (e) => {
                if (this.videoIframe){
                  this.toggleVideoAutoplay(e.target);
                }
            })
        }
      }
  
      customElements.define("media-banner", MediaBanner);
    }
  })();